import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Grid,
  Box,
  Typography,
  Button,
} from '@mui/material'

import { Add, Close } from '@mui/icons-material'
import { useBonusDialog, useWageringActions } from '@/views/bonus-engine/hooks'
import { DialogsEnum } from '@/enums'

import { WageringTableComponent } from './'

export const WageringContributionDialog = () => {
  const { t } = useTranslation()

  const { dialogs, toggleDialog } = useBonusDialog()

  const { getAllWageringCategory, getAllCategories } = useWageringActions()

  const listDialogs = [
    DialogsEnum.DIALOG_WAGERING_CONTRIBUTION,
    DialogsEnum.DIALOG_WAGERING_CONTRIBUTION_FORM,
  ]

  useEffect(() => {
    getAllCategories()
    getAllWageringCategory()
  }, []) // eslint-disable-line

  const handleCloseDialog = () => {
    toggleDialog(false, DialogsEnum.DIALOG_WAGERING_CONTRIBUTION)
  }

  const addNewWagering = () => {
    toggleDialog(true, DialogsEnum.DIALOG_WAGERING_CONTRIBUTION_FORM)
  }

  return (
    <Dialog
      open={
        dialogs.findIndex(
          (dialog) =>
            dialog.open &&
            listDialogs.findIndex((id) => id === dialog.id) !== -1,
        ) !== -1
      }
      aria-labelledby="dialog-title"
      fullWidth
      sx={{
        '& .MuiDialog-paperFullWidth': {
          width: '800px',
          maxWidth: '100%',
        },
      }}
    >
      <DialogTitle id="dialog-title">
        <Box mb={1} display="flex" justifyContent="space-between" width="100%">
          <Typography fontWeight={700} variant="h5" sx={{ mt: 0.5, pl: 1 }}>
            {t('wageringContributionCategory')}
          </Typography>
          <Box display="flex" alignItems="center">
            <Button
              type="submit"
              variant="contained"
              color="primary"
              size="small"
              startIcon={<Add />}
              onClick={() => addNewWagering()}
              sx={{ height: '30px', mr: 2 }}
            >
              {t('labels.add')}
            </Button>
            <IconButton onClick={handleCloseDialog}>
              <Close />
            </IconButton>
          </Box>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <WageringTableComponent />
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  )
}
